/**
 * 表单模式
 */
export enum FormMode {
  /**
   * 详情
   */
  READ = 'read',

  /**
   * 新增
   */
  CREATE = 'create',

  /**
   * 修改
   */
  UPDATE = 'update'
}
